import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function LegalNotices() {
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <header className="bg-white border-b sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-3">
          <Link to="/">
            <ArrowLeft className="w-5 h-5 text-muted-foreground hover:text-foreground" />
          </Link>
          <h1 className="text-lg font-bold">Mentions legales</h1>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="bg-white rounded-2xl border p-6 sm:p-10 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <div>
            <h2 className="text-xl font-bold text-foreground mb-2">Mentions legales</h2>
            <p>Conformement aux dispositions de la loi n. 2004-575 du 21 juin 2004 pour la confiance dans l'economie numerique (LCEN).</p>
          </div>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">1. Editeur du site</h3>
            <p>Green Teva Energie<br />
            Forme juridique : SAS<br />
            Email : contact@greenteva-energies.fr<br />
            Directeur de la publication : M. Cohen Yarone</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">2. Hebergement</h3>
            <p>Le site est heberge par :<br />
            Emergent Labs<br />
            Infrastructure cloud securisee, localisee en Union Europeenne.</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">3. Propriete intellectuelle</h3>
            <p>L'ensemble des contenus presents sur le site (textes, images, logos, graphismes, icones, logiciels) est la propriete exclusive de Green Teva Energie ou de ses partenaires et est protege par les lois francaises et internationales relatives a la propriete intellectuelle.</p>
            <p className="mt-2">Toute reproduction, representation, modification, publication ou adaptation de tout ou partie des elements du site est interdite, sauf autorisation ecrite prealable de Green Teva Energie.</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">4. Protection des donnees personnelles</h3>
            <p>Conformement au Reglement General sur la Protection des Donnees (RGPD) et a la loi Informatique et Libertes, vous disposez de droits sur vos donnees personnelles. Pour en savoir plus, consultez notre <Link to="/confidentialite" className="text-green-600 underline">Politique de confidentialite</Link>.</p>
            <p className="mt-2">Pour exercer vos droits ou pour toute question relative a vos donnees personnelles, contactez-nous a : <strong>contact@greenteva-energies.fr</strong></p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">5. Cookies</h3>
            <p>Le site utilise des cookies. Vous pouvez configurer vos preferences via le bandeau cookies affiche lors de votre premiere visite ou a tout moment dans les parametres de votre navigateur. Pour plus de details, consultez notre <Link to="/confidentialite" className="text-green-600 underline">Politique de confidentialite</Link>.</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">6. Limitation de responsabilite</h3>
            <p>Green Teva Energie ne pourra etre tenue responsable des dommages directs et indirects causes au materiel de l'utilisateur, lors de l'acces au site. Green Teva Energie decline toute responsabilite quant a l'utilisation qui pourrait etre faite des informations et contenus presents sur le site.</p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-foreground mb-2">7. Droit applicable</h3>
            <p>Tout litige en relation avec l'utilisation du site est soumis au droit francais. La competence exclusive est attribuee aux tribunaux competents de Paris.</p>
          </section>
        </div>
      </main>
    </div>
  );
}
